import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type AIGenerateFormData = {
  objective: string;
  style: string;
  subStyle: string;
};

interface AIGenerateFormState {
  aiData: AIGenerateFormData | null;
  setAiData: (data: Partial<AIGenerateFormData>) => void;
  createAiData: (data: Partial<AIGenerateFormData>) => void;
  clearAiData: () => void;
}

export const useAiStore = create<AIGenerateFormState>()(
  persist(
    (set, get) => ({
      aiData: null,
      setAiData: (aiData) => {
        const currentAiData = get().aiData;
        if (currentAiData) {
          set({
            aiData: {
              ...currentAiData,
              ...aiData,
            },
          });
        }
      },
      createAiData: (data) => {
        const newAiData: AIGenerateFormData = {
          objective: data.objective || '',
          style: data.style || '',
          subStyle: data.subStyle || '',
        };
        set({ aiData: newAiData });
      },
      clearAiData: () => {
        set({ aiData: null });
      },
    }),
    {
      name: 'ai-storage', // localStorageのキー名
      partialize: (state) => ({ aiData: state.aiData }), // 永続化する状態を指定
    }
  )
);
